import { useState } from 'react';

import { type DashRange } from '@/lib/sales-metrics';
import cn from '@/utils/cn';

export type PendingPreset = '1m' | '2m' | '3m';

export const pendingPresetRange = (p: PendingPreset): DashRange => {
  const months = p === '1m' ? 1 : p === '2m' ? 2 : 3;
  const to = new Date();
  const from = new Date();
  from.setMonth(from.getMonth() - months);
  return { from, to, label: `Past ${months} month${months > 1 ? 's' : ''}` };
};

const PRESETS: { key: PendingPreset; label: string }[] = [
  { key: '1m', label: '1 month' },
  { key: '2m', label: '2 months' },
  { key: '3m', label: '3 months' },
];

interface PendingFilterProps {
  range: DashRange;
  onChange: (r: DashRange) => void;
}

export function PendingFilter({ range, onChange }: PendingFilterProps) {
  const [mode, setMode] = useState<PendingPreset>('1m');

  const pick = (m: PendingPreset) => {
    setMode(m);
    onChange(pendingPresetRange(m));
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="flex items-center gap-0.5 rounded-md border border-border bg-background p-0.5">
        {PRESETS.map((p) => (
          <button
            key={p.key}
            type="button"
            onClick={() => pick(p.key)}
            className={cn(
              'min-h-9 rounded-sm px-3 py-1.5 text-[11px] font-semibold transition-colors sm:min-h-0 sm:px-2 sm:py-1',
              mode === p.key
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:text-foreground',
            )}
          >
            {p.label}
          </button>
        ))}
      </div>
      <span className="sr-only">{range.label}</span>
    </div>
  );
}
